module.exports = __webpack_public_path__ + "img/ngn-network.94eb1003.svg";